/*eslint-disable */
import libphonenumber from '../components/shared/react-intl-tel-input/libphonenumber.js';
export default libphonenumber;
